import { PendingAgreementSignature } from 'types/Agreement';
import { DaycareAvailabilityDate } from 'types/Availability';
import { Customer } from 'types/Customer';
import { MarketplaceServiceCategory } from 'types/Marketplace';
import { Pet } from 'types/Pet';
import { Staff } from 'types/Staff';
import {
    CheckoutView,
    OnlineBookingItem,
    OnlineBookingStep,
    SessionBusinessArea
} from 'types/OnlineBooking';
import { WalkingAvailability, WalkingEligibility, WalkingStaffAvailability } from 'types/Walking';

export interface OnlineBookingWalkingRequestState<T> {
    loading: boolean;
    data?: T;
    error?: string;
}

export interface OnlineBookingWalkingCache {
    eligibility: Record<string, OnlineBookingWalkingRequestState<WalkingEligibility>>;
    staffAvailability: Record<string, OnlineBookingWalkingRequestState<WalkingStaffAvailability>>;
    availability: Record<string, OnlineBookingWalkingRequestState<WalkingAvailability>>;
    lastBookingError?: string;
    lastBookingErrorItemUuid?: string;
}

export interface OnlineBookingState extends Record<SessionBusinessArea, OnlineBookingWalkingCache> {
    isLoading: boolean;
    isPending: boolean;

    status: OnlineBookingStatus;

    lastStep?: OnlineBookingStep;
    currentStep: OnlineBookingStep;
    checkoutView: CheckoutView;

    lastCategory?: MarketplaceServiceCategory;
    currentCategory?: MarketplaceServiceCategory;
    evaluationServiceCategory?: MarketplaceServiceCategory;

    customer: Customer;

    selectedStaff?: Staff;
    selectedPets: Array<Pet>;

    bookingItems: Array<OnlineBookingItem>;

    daycareAvailabilityByDate: Record<string, DaycareAvailabilityDate>;
    daycareAvailabilityLoadingByDate: Record<string, boolean>;
    daycareAvailabilityRequestKeyByDate: Record<string, string>;

    completedCategories: number;

    daycareAvailability?: DaycareAvailabilityDate;
    daycareAvailabilityLoading: boolean;
    daycareAvailabilityRequestKey?: string;

    boardingAvailability?: DaycareAvailabilityDate;
    boardingAvailabilityLoading: boolean;
    boardingAvailabilityRequestKey?: string;

    agreementSignatures: Array<PendingAgreementSignature>;

    notes?: string;

    // Business area the in-progress waitlist request is for (set from the date step CTA)
    waitlistCategory?: MarketplaceServiceCategory;
}

export enum OnlineBookingStatus {
    Initial,
    Error,

    Initializing,
    Initialized,

    CreateCustomerStart,
    CreateCustomerSuccess,

    AuthenticateCustomerStart,
    AuthenticateCustomerSuccess,

    SavePetStart,
    SavePetSuccess,

    GetGroomingStaffNextAvailableDateStart,
    GetGroomingStaffNextAvailableDateSuccess,
    GetGroomingStaffAvailabilityStart,
    GetGroomingStaffAvailabilitySuccess,

    CreateBookingStart,
    CreateBookingSuccess,
    ConfirmBookingDepositStart,
    ConfirmBookingDepositSuccess,

    CreateWaitlistStart,
    CreateWaitlistSuccess
}
